import styled, { useTheme } from 'styled-components';

import { Image, Text, utils } from '@desygner/ui-common-components';

import { ExternalShareType } from '../ShareAccess.types';

const ITEM_WIDTH = 90;

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ${utils.rem(ITEM_WIDTH)};
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  border: ${({ theme }) =>
    `${utils.rem(theme.Border.Size.Small)} solid
      transparent`};
  cursor: pointer;
  transition: ${({ theme }) => `border-color ${theme.Transition.Timing.Out};`};

  &:hover {
    border-color: ${({ theme }) => theme.Color.Neutrals.Border};
    transition: ${({ theme }) => `border-color ${theme.Transition.Timing.In};`};
  }
`;

const StyledLogo = styled.div`
  display: flex;
  align-items: stretch;
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

const StyledText = styled.div`
  text-align: center;
`;

export type SingleExternalShareProps = {
  share: ExternalShareType;
  onClick: () => void;
};

export function SingleExternalShare({ share, onClick }: SingleExternalShareProps) {
  const theme = useTheme();

  return (
    <StyledWrapper onClick={onClick}>
      <StyledLogo>
        <Image
          source={share.iconUrl}
          alt={share.label}
          width={theme.Icon.Size.Medium}
          height={theme.Icon.Size.Medium}
        />
      </StyledLogo>

      <StyledText>
        <Text size="Small" color={theme.Color.Neutrals.Dark}>
          {share.label}
        </Text>
      </StyledText>
    </StyledWrapper>
  );
}
